import { Component, Vue } from 'vue-property-decorator';

/** Теги элементов формы, для которых гасится дефолт браузера по Numpad Enter */
const FORM_TAGS = ['INPUT', 'SELECT', 'TEXTAREA', 'BUTTON'];

/**
 * Переход к следующему месяцу по клавише Enter цифрового блока (Numpad).
 *
 * Дублирует поведение Tab: Numpad Enter переводит курсор в следующую редактируемую
 * графу месяца той же строки. Обычный Enter основного блока клавиатуры миксином не
 * обрабатывается — за ним сохраняется прежнее поведение компонента (переход на
 * следующую строку в той же графе месяца).
 */
@Component
export default class NumpadEnterMixin extends Vue {
    /** Enter нажат именно на цифровом блоке (Numpad) */
    public isNumpadEnter(event: KeyboardEvent): boolean {
        // location === 3 (DOM_KEY_LOCATION_NUMPAD) — запасной вариант для браузеров без event.code
        return event.code === 'NumpadEnter' || event.location === 3;
    }

    /**
     * Гасит дефолт браузера по Numpad Enter, если фокус находится на элементе формы,
     * чтобы исключить случайную отправку данных.
     */
    public preventNumpadEnterDefault(event: KeyboardEvent): void {
        if (!this.isNumpadEnter(event)) { return; }
        const target = event.target as HTMLElement | null;
        if (target && FORM_TAGS.includes(target.tagName)) {
            event.preventDefault();
        }
    }

    /** Индекс следующего редактируемого месяца строки; null — если текущий месяц последний */
    public nextEditedMonth(monthIndx: number, editedArr: boolean[]): number | null {
        for (let i = monthIndx + 1; i < editedArr.length; i++) {
            if (editedArr[i]) { return i; }
        }
        return null;
    }

    /** Индекс первого редактируемого месяца строки; null — если редактируемых месяцев нет */
    public firstEditedMonth(editedArr: boolean[]): number | null {
        const indx = editedArr.indexOf(true);
        return indx === -1 ? null : indx;
    }

    /** Ставит курсор в поле по ref и выделяет его содержимое */
    public async selectInputByRef(refName: string): Promise<boolean> {
        await this.$nextTick();
        const ref: any = this.$refs[refName];
        const input: HTMLInputElement | undefined = Array.isArray(ref) ? ref[0] : ref;
        if (!input) { return false; }
        input.focus();
        input.select();
        return true;
    }
}
